import React from 'react';
import { Check, KeyRound, Wifi, FileText, CreditCard, Send, AlertTriangle } from 'lucide-react';
import { MockFrame, SELENA_AVATAR } from './ui';

const Row = ({ children, className = '' }) => (
  <div className={`flex items-center justify-between rounded-2xl border border-stone-200 px-4 py-3.5 ${className}`}>{children}</div>
);

const PLANNING = [
  { t: 'Ménage Loft Marais', who: 'Amina K.', h: '10:00', done: true },
  { t: 'Check-in Villa Bordeaux', who: 'Marc D.', h: '14:00', live: true },
  { t: 'Maintenance clim Studio Lyon', who: 'Pierre L.', h: '15:30' },
  { t: 'Ménage Chalet Annecy', who: 'Sarah B.', h: '11:00' },
];

export const OpsPlanningMock = () => (
  <MockFrame>
    <div className="mb-4 flex items-center justify-between border-b border-stone-100 pb-4">
      <p className="font-semibold text-stone-900">Planning du 10 avril</p>
      <p className="text-xs text-stone-500">12 tâches</p>
    </div>
    <div className="space-y-3">
      {PLANNING.map((p) => (
        <Row key={p.t}>
          <div className="flex items-center gap-3">
            {p.done ? (
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500 text-white"><Check className="h-3.5 w-3.5" strokeWidth={3} /></span>
            ) : (
              <span className={`flex h-6 w-6 items-center justify-center rounded-full ${p.live ? 'bg-[#FFE4DA]' : 'bg-stone-100'}`}>
                <span className={`h-2 w-2 rounded-full ${p.live ? 'bg-[#EA4A1F]' : 'bg-stone-600'}`} />
              </span>
            )}
            <div>
              <p className={`text-sm font-semibold ${p.done ? 'text-stone-400 line-through' : 'text-stone-900'}`}>{p.t}</p>
              <p className="text-xs text-stone-500">{p.who}</p>
            </div>
          </div>
          <span className="font-mono text-xs text-stone-700">{p.h}</span>
        </Row>
      ))}
    </div>
    <div className="mt-4 flex items-center justify-between rounded-2xl border border-dashed border-[#EA4A1F]/30 bg-[#FFF7F3] px-4 py-3.5">
      <span className="text-xs text-stone-600">Paiements prestataires ce mois</span>
      <span className="font-bold text-[#EA4A1F]">1 248 €</span>
    </div>
  </MockFrame>
);

const TABS = ['Réservation', 'Check-in', 'Guide', 'Extras', 'Paiement', 'Contrat', 'Contact'];

export const GuestPageMock = () => (
  <MockFrame>
    <div className="flex items-start justify-between border-b border-stone-100 pb-4">
      <div>
        <p className="font-semibold text-stone-900">guest.ozcbnb.com</p>
        <p className="text-xs text-stone-500">Loft Marais · Sophie M. · 3 nuits</p>
      </div>
      <span className="rounded-full bg-[#FFF1EB] px-2.5 py-1 text-[11px] font-semibold text-[#EA4A1F]">7 onglets</span>
    </div>
    <div className="my-4 flex flex-wrap gap-1.5">
      {TABS.map((t, i) => (
        <span key={t} className={`rounded-full px-3 py-1.5 text-[11px] font-medium ${i === 0 ? 'bg-[#EA4A1F] text-white' : 'border border-stone-200 text-stone-700'}`}>{t}</span>
      ))}
    </div>
    <div className="space-y-3">
      <Row><div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600"><KeyRound className="h-4 w-4" /></span><div><p className="text-sm font-semibold">Code d'accès</p><p className="text-xs text-stone-500">Affiché à partir du 12 avril 08:00</p></div></div><span className="font-mono tracking-widest text-stone-800">•••• ••</span></Row>
      <Row><div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-xl bg-sky-50 text-sky-600"><Wifi className="h-4 w-4" /></span><div><p className="text-sm font-semibold">WiFi</p><p className="text-xs text-stone-500">LoftMarais_5G</p></div></div><span className="font-mono text-xs text-stone-500">Copier</span></Row>
      <Row><div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-50 text-amber-600"><FileText className="h-4 w-4" /></span><div><p className="text-sm font-semibold">Contrat de location</p><p className="text-xs text-stone-500">À signer</p></div></div><span className="rounded-full bg-[#FFE4DA] px-2.5 py-1 text-[11px] font-semibold text-[#EA4A1F]">Signer</span></Row>
      <Row><div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-xl bg-rose-50 text-rose-600"><CreditCard className="h-4 w-4" /></span><div><p className="text-sm font-semibold">Arrivée anticipée</p><p className="text-xs text-stone-500">+ petit-déjeuner</p></div></div><span className="font-bold text-[#EA4A1F]">45 €</span></Row>
    </div>
  </MockFrame>
);

export const SelenaMock = () => (
  <MockFrame className="!p-0 overflow-hidden">
    <div className="flex items-center gap-3 border-b border-stone-100 px-6 py-4">
      <img src={SELENA_AVATAR} alt="Selena" className="h-11 w-11 rounded-full object-cover" />
      <div className="flex-1">
        <p className="font-semibold text-stone-900">Selena</p>
        <p className="flex items-center gap-1.5 text-xs text-emerald-600"><span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-500" />En ligne · 24h/24</p>
      </div>
      <span className="font-mono text-xs text-stone-400">03:12</span>
    </div>
    <div className="space-y-3 bg-[#FFFBF8] px-6 py-5 text-sm">
      <p className="ml-auto w-fit max-w-[80%] rounded-2xl rounded-br-sm bg-[#EA4A1F] px-4 py-2.5 text-white">Bonsoir, le code de la porte ne marche pas…</p>
      <p className="w-fit max-w-[85%] rounded-2xl rounded-bl-sm border border-stone-200 bg-white px-4 py-2.5 text-stone-800">Pas de panique Sophie ! Tapez le code puis appuyez sur la touche ✓ en bas à droite. Si ça bloque encore, je préviens votre hôte tout de suite.</p>
      <div className="flex items-center gap-2 rounded-xl border border-[#EA4A1F]/25 bg-[#FFF1EB] px-3 py-2 text-xs font-medium text-[#EA4A1F]">
        <AlertTriangle className="h-3.5 w-3.5" /> Alerte envoyée à l'hôte par e-mail
      </div>
    </div>
    <div className="flex items-center gap-2 border-t border-stone-100 px-4 py-3">
      <div className="flex-1 rounded-xl bg-stone-100 px-4 py-2.5 text-xs text-stone-400">Écrivez à Selena…</div>
      <span className="rounded-xl bg-[#EA4A1F] p-2.5 text-white"><Send className="h-4 w-4" /></span>
    </div>
  </MockFrame>
);

const FUNNEL = [
  ['J-3', 'Confirmation de réservation', 'Email'],
  ['J-1', "Instructions d'arrivée + code", 'Email'],
  ['J+0', 'Message de bienvenue', 'Lien voyageur'],
  ['J+1', 'Check-in OK ? Besoin d\'aide ?', 'Selena'],
  ['J+3', "Demande d'avis après séjour", 'Email'],
];

export const MessagesMock = () => (
  <MockFrame>
    <div className="mb-4 flex items-center justify-between border-b border-stone-100 pb-4">
      <div><p className="font-semibold text-stone-900">Tunnel automatisé</p><p className="text-xs text-stone-500">Loft Marais · Sophie M.</p></div>
      <span className="rounded-full bg-[#FFF1EB] px-2.5 py-1 text-[11px] font-semibold text-[#EA4A1F]">Automatique</span>
    </div>
    <div className="space-y-3">
      {FUNNEL.map(([d, t, c]) => (
        <Row key={d}>
          <div className="flex items-center gap-3">
            <span className="w-10 font-mono text-xs font-bold text-[#EA4A1F]">{d}</span>
            <div><p className="text-sm font-semibold text-stone-900">{t}</p><p className="text-xs text-stone-500">{c} · sans mention OZCBNB</p></div>
          </div>
          <Check className="h-4 w-4 text-emerald-500" />
        </Row>
      ))}
    </div>
  </MockFrame>
);
